import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {Row, Col} from 'react-flexbox-grid'
import {SlideDown} from 'react-slidedown'
import format from '../../helpers/format'
import config from '../../config'
import {
  ContainerDivs,
  Link,
  LinkIcon,
} from '../../components'
import Styles from './TargetDateGrid.css'


@CSSModules(Styles)
class TargetDateGridItem extends Component {
  static propTypes = {
    // the target date series object
    targetDateSeries: PropTypes.object,
  }
  constructor(props){
    super(props)
  }
  render() {
    if (!this.props.targetDateSeries) { return null }
    const { targetDateSeries } = this.props
    const sName = format.sanitize(targetDateSeries.strategy_name)
    const sFamName = format.sanitize(targetDateSeries.fund_family_label)
    const url = config.routes.targetDateFunds + '/' + sName

    // console.log('sFamName')
    // console.log(sFamName)

    let hasLogo = false
    let logo = null
    try {
      logo = require('../../../static/images/fam/'+sFamName+'.png')
      hasLogo = true
    }
    catch (e) {
      console.log('')
    }

    const iconsEnv = {
      fff: require( '../../../static/images/icons/fff-icon.svg' ),
      dff: require( '../../../static/images/icons/dff-icon.svg' ),
      ffb: require( '../../../static/images/icons/ffb-icon.svg' ),
      ffi: require( '../../../static/images/icons/ffi-icon.svg' ),
    }
    const iconsSoc = {
      gef: require( '../../../static/images/icons/gef-icon.svg' ),
      gff: require( '../../../static/images/icons/gff-icon.svg' ),
      pff: require( '../../../static/images/icons/pff-icon.svg' ),
      wff: require( '../../../static/images/icons/wff-icon.svg' ),
      tff: require( '../../../static/images/icons/tff-icon.svg' )
    }

    const redOctagon = (
      <div styleName='result-shape-txt-wrap'>
        <div styleName='result-shape-wrap'>
          <div title='Poor' styleName='red-octagon'/>
        </div>
      </div>
    )

    const yellowSquare = (
      <div styleName='result-shape-txt-wrap'>
        <div styleName='result-shape-wrap'>
          <div title='Fair' styleName='yellow-square'/>
        </div>
      </div>
    )

    const greenCircle = (
      <div styleName='result-shape-txt-wrap'>
        <div styleName='result-shape-wrap'>
          <div title='Good' styleName='green-circle'/>
        </div>
      </div>
    )

    const graySquare = (
      <div styleName='result-shape-txt-wrap'>
        <div styleName='result-shape-wrap'>
          <div title='N/A' styleName='gray-square'/>
        </div>
      </div>
    )

    const shapeDecider = (fund, key) => {
      const grade_label = {
        fff: 'grade_fossil',
        dff: 'grade_deforestation',
        ffb: 'grade_fossil_bank',
        ffi: 'grade_fossil_insure',
        gef: 'grade_gender_equality',
        gff: 'grade_guns',
        pff: 'grade_prison_industrial_complex',
        wff: 'grade_military',
        tff: 'grade_tobacco',
      }[key]

      const grade = fund[grade_label]
      if (grade >= 4) {
        return redOctagon
      } else if (grade >= 2) {
        return yellowSquare
      } else if (grade === 1) {
        return greenCircle
      }
      return graySquare
    }

    let { strategy_name } = targetDateSeries
    strategy_name = strategy_name.slice(strategy_name.length - 7) === ' Series' ?
      strategy_name.slice(0, strategy_name.length - 7) :
      strategy_name

    //
    return (
      <Col styleName='grid-item-wrap' xs={12} sm={12}>
        <Link
          to={url}
          title={strategy_name}
        >
          <div styleName='grid-item-box'>
            <div styleName='box-title-wrap'>
              { hasLogo ?
                  <img
                    src={logo}
                    alt={strategy_name}
                    styleName='box-title-logo'
                  /> :
                  null
              }

              <div styleName='box-title'>
                { strategy_name }
                {
                  targetDateSeries.sustainable_investment ?
                    <span styleName='leaf'>
                      <LinkIcon faclass='fa-leaf' />
                    </span> :
                    null
                }
              </div>
              <div styleName='box-subtitle'>
                { targetDateSeries.fund_legal_name }
                { targetDateSeries.ticker && targetDateSeries.ticker !== 'N' ?
                    ` (${targetDateSeries.ticker})` :
                    null
                }
              </div>
            </div>

            <div styleName='scores-wrap'>
              <div styleName='scores-env'>
                <div styleName='scores-label'>
                  Environment
                </div>
                <div styleName='scores-flex'>
                  {
                    Object.keys(iconsEnv).map((e, i) => {
                      return (
                        <div
                          key={'grid-item-'+sName+'-'+i}
                          styleName='scores-item'
                        >
                          <div styleName='scores-img'>
                            <img
                              src={iconsEnv[e]}
                              alt={'Tmp'}
                            />
                          </div>
                          <div>
                            { shapeDecider(targetDateSeries, e) }
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
              <div styleName='scores-soc'>
                <div styleName='scores-label'>
                  Social
                </div>
                <div styleName='scores-flex'>
                  {
                    Object.keys(iconsSoc).map((e, i) => {
                      return (
                        <div
                          key={'grid-item-'+sName+'-'+i}
                          styleName='scores-item'
                        >
                          <div styleName='scores-img'>
                            <img
                              src={iconsSoc[e]}
                              alt={'Tmp'}
                            />
                          </div>
                          <div>
                            { shapeDecider(targetDateSeries, e) }
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </div>

          </div>
        </Link>
      </Col>
    )
  }
}


@CSSModules(Styles)
export default class TargetDateGrid extends Component {
  static propTypes = {
    // bool for page extras or no
    page: PropTypes.bool
  }
  constructor(props){
    super(props)
    this.state = {
      show: false
    }
  }
  render() {
    if (!config.targetDateSeries) { return null }

    const NUMBER_TO_ALWAYS_SHOW = 4
    const targetDateSeriesList = [].concat(config.targetDateSeries)

    //
    if (this.props.page) {
      // IF THIS IS THE TARGET DATE PAGE
      return (
        <ContainerDivs>
          <div styleName='grid-anchor' id='companies'/>
          <h1 styleName='small-page-title'>
            Target date funds
          </h1>
          <div styleName='grid-info'>
            Target date funds are groups of funds, where each fund in the
            series targets a different mix of stocks and bonds for investors
            with different retirement time horizons. The default option in
            employer-offered retirement plans is often a target date fund
            series. Below are some of the largest target date fund series,
            rated using the 2050 fund.
          </div>
          <Row styleName='grid-boxes'>
            {
              targetDateSeriesList.map(
                (targetDateSeries, i) => {
                  return <TargetDateGridItem
                    key={'target-date-grid-item-'+i}
                    targetDateSeries={targetDateSeries}
                  />
                }
              )
            }
          </Row>
          <div styleName='content-wrap'>
            <h2>How are these target date series chosen?</h2>
            <p>
              We think every target date fund series should be rated on
              sustainability. Our goal is to expand this database over the
              next year to cover all target date fund series offered by major
              asset managers. We started with these target date series because
              they are some of the largest and most commonly-owned target date
              funds on the market, with hundreds of billions in assets under
              management. Check back regularly to see if your target date fund
              series has been added to our database.
            </p>
            <p>
              <b>Want us to rate the target date fund series in your
              retirement plan? <Link
                to={config.links.contact}
                title='Contact us'
                xstrong
              >Get in touch with us<LinkIcon /></Link></b>
            </p>
          </div>
        </ContainerDivs>
      )
    } else {
      // IF THIS IS THE HOME PAGE
      return (
        <div>
          <Row styleName='grid-boxes'>
            { /* SHOW A FEW ITEMS AT FIRST */ }
            {
              targetDateSeriesList.slice(0, NUMBER_TO_ALWAYS_SHOW).map(
                (targetDateSeries, i) => {
                  return <TargetDateGridItem
                    key={'target-date-grid-item-'+i}
                    targetDateSeries={targetDateSeries}
                  />
                }
              )
            }
            { /* SHOW MORE BUTTON */ }
            {
              !this.state.show ?
                <div styleName='show-more-button-wrap'>
                  <button
                    onClick={
                      () => {
                        this.setState({show: !this.state.show})
                      }
                    }
                    title='Show more'
                    styleName='show-more-button'
                  >
                    Show more<LinkIcon faclass='fa-angle-double-down' />
                  </button>
                </div> :
                null
            }
          </Row>
          { /* IF SHOW MORE CLICKED, SLIDE DOWN MORE ITEMS */ }
          <SlideDown>
            <Row styleName='grid-boxes'>
              {
                this.state.show ?
                  targetDateSeriesList.slice(NUMBER_TO_ALWAYS_SHOW, targetDateSeriesList.length).map(
                    (targetDateSeries, i) => {
                      return <TargetDateGridItem
                        key={'target-date-grid-item-'+(i+3)}
                        targetDateSeries={targetDateSeries}
                      />
                    }
                  ) :
                  null
              }
            </Row>
          </SlideDown>
        </div>
      )
    }
  }
}
